import { tableActions, customTableActions } from './tableActions'
import { tableFields } from './tableFields'
import { tableConfig } from './tableConfig'

export default ({
    tableFields,
    tableActions,
    tableConfig,
    customTableActions
})